import { finanzcheck } from '@finanzcheck/teal-mui-theme';
import { BulletPoints, BulletPointsProps } from './BulletPoints';

export const BulletPointsExclusiveBadges: React.FC<BulletPointsProps> = ({
  bulletPoints,
  textColor,
}) => {
  const darkIconUrl = '/static/icons/checkSeal.svg';
  const lightIconUrl = '/static/icons/checkSealWhite.svg';
  const bulletUrl =
    textColor === finanzcheck.colors.text.blue ? darkIconUrl : lightIconUrl;
  return (
    <BulletPoints
      image={bulletUrl}
      bulletPoints={bulletPoints}
      textColor={textColor || finanzcheck.colors.text.blue}
    />
  );
};
